import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight, Mic, GraduationCap, FlaskConical, Megaphone, Microscope, Briefcase, Users, Globe, Award } from "lucide-react";
import { Kicker, Reveal } from "../motion";

const MENTOR_ICONS = [Mic, GraduationCap, FlaskConical, Megaphone];
const OPPS = [
  { k: "o1", Icon: Microscope },
  { k: "o2", Icon: Briefcase },
  { k: "o3", Icon: Users },
  { k: "o4", Icon: Globe },
  { k: "o5", Icon: Award },
];

export default function MentorOpps() {
  const { t } = useTranslation();
  const ways = t("professionals.ways", { returnObjects: true });

  return (
    <section className="surface-1 py-20 lg:py-28" data-testid="home-mentor-opps">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-6">
        <Reveal className="lg:col-span-7">
          <div className="paper p-8 lg:p-10 h-full flex flex-col" data-testid="home-mentorship">
            <Kicker>{t("home.mentorship.kicker")}</Kicker>
            <h2 className="font-display text-3xl lg:text-4xl mt-4 leading-[1.08] text-ink max-w-lg">{t("home.mentorship.title")}</h2>
            <p className="mt-4 text-slate max-w-lg">{t("home.mentorship.body")}</p>
            <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-3">
              {Array.isArray(ways) && ways.map((w, i) => {
                const Icon = MENTOR_ICONS[i] || Mic;
                return (
                  <div key={i} className="group flex flex-col items-center text-center gap-3 p-4 rounded-xl bg-ivory border border-line hover:border-gold/60 transition-colors">
                    <span className="icon-tile !h-11 !w-11"><Icon className="h-4.5 w-4.5" /></span>
                    <span className="text-xs font-semibold text-ink leading-tight">{w.t}</span>
                  </div>
                );
              })}
            </div>
            <div className="mt-auto pt-8">
              <Link to="/professionals" data-testid="home-mentorship-cta" className="btn-gold-outline !py-2.5 !px-5 !text-[11px]">
                {t("home.mentorship.cta")} <ArrowRight className="h-3.5 w-3.5 rtl:rotate-180" />
              </Link>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.12} className="lg:col-span-5">
          <div className="paper p-8 lg:p-10 h-full flex flex-col" data-testid="home-opportunities">
            <div className="flex items-end justify-between gap-4">
              <div>
                <Kicker>{t("home.opps.kicker")}</Kicker>
                <h2 className="font-display text-3xl lg:text-4xl mt-4 leading-[1.08] text-ink">{t("home.opps.title")}</h2>
              </div>
              <Link to="/opportunities" data-testid="home-opps-link" className="inline-flex items-center gap-2 text-sm font-semibold text-forest gxr-link whitespace-nowrap">
                {t("common.viewAll")} <ArrowRight className="h-4 w-4 rtl:rotate-180" />
              </Link>
            </div>
            <div className="mt-8 grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-3 gap-3">
              {OPPS.map(({ k, Icon }) => (
                <Link key={k} to="/opportunities" className="group flex flex-col items-center text-center gap-3 p-4 rounded-xl bg-ivory border border-line hover:border-gold/60 transition-colors">
                  <span className="icon-tile !h-11 !w-11"><Icon className="h-4.5 w-4.5" /></span>
                  <span className="text-xs font-semibold text-ink leading-tight">{t(`home.opps.${k}`)}</span>
                </Link>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
